module.exports = __webpack_public_path__ + "img/hr.4c24a346.png";